<script setup lang="ts">
import { useEoTracking } from 'storyblok/services/eoTracking'

const route = useRoute()
const showRedirectModal = ref(false)
const frame = route.query.frame === 'true'
const isMenuOpen = ref(false)
const storyblokApi = useStoryblokApiV2()

const { stories } = await storyblokApi.getStories({
  by_slugs: ['layout/*'],
}) as any

const layoutData = {
  navigation: stories?.find((item: any) => item.slug === 'navigation'),
  footer: stories?.find((item: any) => item.slug === 'footer'),
  ldjson: stories?.find((item: any) => item.slug === 'ldjson'),
  eotracking: stories?.find((item: any) => item.slug === 'eotracking'),
}

showRedirectModal.value = Object.keys(route.query).includes('isRedirect') && !useCookie('redirect_modal_closed').value

useEoTracking(
  layoutData?.eotracking?.content?.partnerIds,
  layoutData?.eotracking?.content?.excludedReferrers,
)
useStoryblokBridge()
</script>

<template>
  <div>
    <div v-if="frame">
      <NuxtPage :frame="frame" />
    </div>
    <div v-else>
      <TheNavigation v-model:is-menu-open="isMenuOpen" v-bind="layoutData?.navigation?.content" />
      <AppLdJson v-if="layoutData?.ldjson?.content" v-bind="layoutData?.ldjson?.content" />
      <NuxtPage />
      <TheFooter v-bind="layoutData?.footer?.content" />
      <ModalRpRedirect v-if="showRedirectModal" />
    </div>
  </div>
</template>
